// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3GZnb","sendOtp":"AuthorizeToLogin_sendOtp__xrqDJ"};